.empty-table{margin-bottom:3em}.allergies-submitted .allergy.ng-invalid,.reactions-submitted .reaction.ng-invalid{border:red 1px solid!important;border-radius:2px}
/*# sourceMappingURL=procedure-add-edit.component-7QWSW5SW.css.map */
